export interface HtmlSlideFile {
    name: string;
    html: string;
}

export function isHtmlFileName(name: string): boolean {
    return /\.(html|htm)$/i.test(name);
}

export function htmlSlideName(fileName: string): string {
    const withoutExtension = fileName.replace(/\.(html|htm)$/i, '').trim();
    return withoutExtension.slice(0, 100) || 'HTML';
}

export function readHtmlSlideFiles(files: File[]): Promise<HtmlSlideFile[]> {
    return Promise.all(
        files.map(
            (file) =>
                new Promise<HtmlSlideFile>((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        resolve({
                            name: htmlSlideName(file.name),
                            html: String(reader.result ?? ''),
                        });
                    };
                    reader.onerror = () => reject(reader.error);
                    reader.readAsText(file);
                })
        )
    );
}
